import { LOCAL_BASE_URL, QA_BASE_URL, DEV_BASE_URL, PROD_BASE_URL } from '../consts'

export const ENV_URLS: Record<string, string> = {
	local: LOCAL_BASE_URL,
	dev: DEV_BASE_URL,
	qa: QA_BASE_URL,
	prod: PROD_BASE_URL,
}

export function useHideInEnvironment(env: 'local' | 'dev' | 'qa' | 'prod'): boolean {
	const currentUrl = window.location.href
	return currentUrl.includes(ENV_URLS[env])
}
